import { BillingReportRequest } from '@core/domain/model/billing-report/billing-report-request.model';
import { MyInvoicesListingItem } from '@core/domain/model/invoices/my-invoices-listing.model';
import { FilterPageOrder } from '@core/services/http-params/model/api-http-params.model';
import { BillingReportListFilter } from '@pages/my-invoices/billing-report/billing-report-listing/model/billing-report-list.model';
import { MyInvoicesFilterFormModel } from '@pages/my-invoices/my-invoices-listing/model/my-invoices-filter-form.model';
import { PaginatorInput } from '@shared/components/paginator/models/paginator-input.model';
import { SortEvent } from '@shared/components/table/sort/model/sort.model';

export interface MyInvoicesState {
  listingData: {
    data: Array<MyInvoicesListingItem>;
    filters: MyInvoicesFilterFormModel & FilterPageOrder;
    error: null | string;
  };
  requestList: {
    data: BillingReportRequest[];
    filter: BillingReportListFilter;
    page: PaginatorInput;
    sort: SortEvent;
    error: string | null;
  };
}

export const myInvoicesInitialState: MyInvoicesState = {
  listingData: {
    data: [],
    filters: {
      pageIndex: 1,
      pageSize: 5,
      sortName: 'FechaEmision',
      sortDir: 'desc',
    },
    error: null,
  },
  requestList: {
    data: [],
    filter: {},
    page: {
      pageIndex: 1,
      pageSize: 5,
    },
    sort: {
      sortName: 'requestDate',
      sortDir: 'desc',
    },
    error: null,
  },
};
